import { useState, useEffect } from 'react';
import { useMemoizedFn } from 'ahooks';
// @ts-ignore
import { merge } from 'lodash-es';

/**
 * 维护自定义图例 交互逻辑
 * @param options 初始化自定义图例选中状态集、echart配置项、echart配置项setter
 * @returns 自定义图例选中状态、自定义图例选中切换事件回调
 */
export default function useChartCustomLegend(options: {
  initialLegendSelected: {
    [key: string]: boolean;
  };
  option: IEChartOption;
  setOption: React.Dispatch<React.SetStateAction<IEChartOption>>;
}) {
  const { initialLegendSelected, option, setOption } = options || {};

  // 自定义图例 选中状态集
  const [legendSelected, setLegendSelected] = useState<{
    [key: string]: boolean;
  }>(initialLegendSelected);

  // 自定义图例 选中change回调
  const handleLegendChange = useMemoizedFn((value) => {
    setLegendSelected({
      ...legendSelected,
      ...value,
    });
  });

  // 图例更新时，更新echart配置项
  useEffect(() => {
    const newOption = merge({}, option, {
      legend: [
        {
          // @ts-ignore
          ...option?.legend?.[0],
          selected: legendSelected,
        },
      ],
    });
    setOption?.(newOption);
  }, [legendSelected]);

  return {
    legendSelected,
    handleLegendChange,
  };
}
